import { render, staticRenderFns } from "./VmProductEditor.vue?vue&type=template&id=33fb8383&scoped=true"
import script from "./VmProductEditor.vue?vue&type=script&lang=js"
export * from "./VmProductEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fb8383",
  null
  
)

export default component.exports